module.exports = __webpack_public_path__ + "img/thumbnail_AlpineGoat_m_melanistic.5319397b.png";